module.exports = __webpack_public_path__ + "img/kitsu.b07d6464.png";